import { render, staticRenderFns } from "./ShortTermAcknowledgeIntervention.vue?vue&type=template&id=e296b668&"
import script from "./ShortTermAcknowledgeIntervention.vue?vue&type=script&lang=js&"
export * from "./ShortTermAcknowledgeIntervention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports